import { Filter } from "./Filter";
export class Query {
    constructor(offset = 0, limit = 10) {
        this.offset = offset;
        this.limit = limit;
        this._filters = [];
    }
    get filters() {
        return [...this._filters];
    }
    addFilter(name, values, op = 'eq') {
        const filter = new Filter(name, values, op);
        this._filters.push(filter);
    }
}
